module.exports = __webpack_public_path__ + "static/JuerixHomepage.c494db9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/JuerixHomepage.png
// module id = 355
// module chunks = 63520936819716